import pb from './images/powerball.jpg'
import mm from './images/megamillions.jpg'

export const power = {
    image: pb,
    classCalled: 'powerballImage',
    imageWidth: 528,
    imageHeight: 587
}

export const mega = {
    image: mm,
    classCalled: 'megaImage',
    imageWidth: 1200,
    imageHeight: 567
}
